import React from 'react';
import PropTypes from 'prop-types';

import OutputText from '@ey/canvascoreservices/OutputText';
import MotifDropdownItem from '@ey/motif-react-wrapper/DropdownItem';
import MotifBadge from '@ey/motif-react-wrapper/Badge';

import Dropdown from '../../../CoreWrappers/Dropdown';
import DropdownHeader from '../../DropdownHeader';
import StyledCountWithTooltip from './StyledCountWithTooltip';
import StyledScrollbar from './StyledScrollbar';
import Button from '../../../CoreWrappers/Button';

const CountWithTooltip = ({
	inactiveLabel,
	activeLabel,
	countLabel,
	itemList = [],
	customItemRender = null,
	customItemSize = null
}) => {
	const renderTrigger = () => <Button variant="text-alt">{activeLabel}</Button>;

	const renderItem = (item, index) => (
		<MotifDropdownItem key={index} type="container">
			<OutputText light title={item} ellipsis>
				{item}
			</OutputText>
		</MotifDropdownItem>
	);

	const renderDropdown = () => {
		const props = {
			placement: 'bottom-left',
			trigger: renderTrigger(),
			topfix: true
		};

		const scrollbarProps = {className: 'customScrollbar'};
		if (customItemRender && customItemSize) scrollbarProps.itemSize = customItemSize;

		return (
			<Dropdown {...props}>
				<DropdownHeader>
					<OutputText ellipsis>{countLabel}</OutputText>
					<MotifBadge value={itemList.length} />
				</DropdownHeader>
				<StyledScrollbar {...scrollbarProps}>
					{itemList.map((item, index) => {
						if (customItemRender !== null) return customItemRender(item, index);
						return renderItem(item, index);
					})}
				</StyledScrollbar>
			</Dropdown>
		);
	};

	return (
		<StyledCountWithTooltip>
			<OutputText body2 ellipsis>{inactiveLabel}</OutputText>
			{itemList.length > 0 && renderDropdown()}
			{itemList.length === 0 && renderTrigger()}
		</StyledCountWithTooltip>
	);
};

CountWithTooltip.propTypes = {
	inactiveLabel: PropTypes.string.isRequired,
	activeLabel: PropTypes.string.isRequired,
	countLabel: PropTypes.string.isRequired,
	itemList: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.string), PropTypes.arrayOf(PropTypes.shape({}))]),
	customItemRender: PropTypes.func,
	customItemSize: PropTypes.string
};

export default CountWithTooltip;
